<template>
  <div id="newCommission">
    <div style="display: flex">
      <div style='background: #FFE4B9;cursor: pointer;padding: 0px 6px;
                      border-radius: 5px;'>
        <a-dropdown placement="bottomCenter" :trigger="['click']">
          <div @click="e => e.preventDefault()" class="right"><a-icon style="margin-right: 5px" type="question-circle" />{{$t('key132')}} <a-icon type="caret-down" /></div>
          <a-menu slot="overlay" @click="menuClick">
            <a-menu-item key="1">
              <div style="color:#999999;padding: 0px 0px 0px 0px;"><pt-icon type="icon-PDF" style="color: #333333"></pt-icon><span style="padding-left: 5px;">{{ $t('key132') }}</span></div>
            </a-menu-item>
            <a-menu-item key="2">
              <div style="color:#999999;padding: 0px 0px 0px 0px"><pt-icon type="icon-PDF" style="color: #333333"></pt-icon><span style="padding-left: 5px;">{{ $t('key133') }}</span></div>
            </a-menu-item>
            <a-menu-item key="3">
              <div style="color:#999999;padding: 0px 0px 0px 0px"><pt-icon type="icon-PDF" style="color: #333333"></pt-icon><span style="padding-left: 5px;">{{ $t('key134') }}</span></div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <a-row>
      <div class="panel_header">
        <div class="circle"></div>
        <div class="panel_text">{{ $t('deal.dealConfirm.dealDO.title') }}</div>
      </div>
    </a-row>
    <a-row v-if="dealConfirmVO" class="info_block">
      <a-row>
        <div class="project_name">
          <div style="flex: 1;">
            <pt-tag color="grey" v-if="dealConfirmVO.type == 2" :text="dealConfirmVO.projectDO.projectName"
                    type="triangle" size="small"></pt-tag>
            <pt-tag color="grey" v-else :text="dealDO.projectName" type="triangle" size="small"></pt-tag>
          </div>
          <div v-if="leaseInfoVO != '~' && leaseInfoVO.id != 0" @click="showLeaseDetails">
            <pt-icon type="icon-xiangqingcopy" class="viewIcon"
                     :title="$t('commission.commissionDetail.projectInfo.titleOne')"></pt-icon>
          </div>
        </div>
      </a-row>
      <div v-if="dealConfirmVO.dealDO.dealOriginType != 2 || dealConfirmVO.projectDO.id">
        <template v-if="leaseInfoVO != '~'">
          <a-row style="padding-left:10px;">
            <a-col :span="8">
              <div class="label">{{ $t('deal.dealConfirm.projectInfo.customerName') }}</div>
              <div class="content">{{ leaseInfoVO.companyName }}</div>
            </a-col>
            <a-col :span="8">
              <div class="label">{{ $t('deal.dealConfirm.projectInfo.mansion') }}</div>
              <div class="content">{{ leaseInfoVO.mansionName }}</div>
            </a-col>
            <a-col :span="8">
              <div class="label">{{ $t('deal.dealConfirm.projectInfo.size') }}</div>
              <div class="content">
                {{ leaseInfoVO.id == 0 ? '~' : leaseAreaInfo }}
                <pt-unit-select type="area" v-model="leaseAreaUnit" :edit-mode="false"></pt-unit-select>
              </div>
            </a-col>
          </a-row>
          <a-row style="padding-left:10px;">
            <a-col :span="8">
              <div class="label">{{ $t('deal.dealConfirm.projectInfo.rent') }}</div>
              <div class="content">{{ leaseInfoVO.id == 0 ? '~' : leaseInfoVO.rent }}
                <pt-unit-select type="rent" v-model="leaseInfoVO.rentUnit" :edit-mode="false"></pt-unit-select>
              </div>
            </a-col>
            <a-col :span="8">
              <div class="label">{{ $t('deal.dealConfirm.projectInfo.signTime') }}</div>
              <div class="content">{{ leaseInfoVO.signTime }}</div>
            </a-col>
            <a-col :span="8">
              <div class="label">{{ $t('deal.dealConfirm.projectInfo.leasePeriod') }}</div>
              <div class="content" v-if="leaseInfoVO.id != '0'">{{ leaseInfoVO.startTime }}-{{ leaseInfoVO.endTime }}
              </div>
              <div class="content" v-if="leaseInfoVO.id == '0'">~</div>
            </a-col>
          </a-row>
        </template>
      </div>
      <div v-else>
        <a-row>
          <a-col :span="8">
            <div class="label">{{ $t('deal.dealConfirm.projectInfo.customerName') }}</div>
            <div class="content">{{ contractVO.customerName }}</div>
          </a-col>
          <a-col :span="4">
            <div class="label">{{ $t('deal.dealConfirm.projectInfo.signTime') }}</div>
            <div class="content">{{ contractVO.signDate | dayjs }}</div>
          </a-col>
          <a-col :span="6">
            <div class="label">{{ $t('deal.dealConfirm.projectInfo.contractPeriod') }}</div>
            <div class="content">
              {{ contractVO.startTime | dayjs }} ~ {{ contractVO.endTime | dayjs }}
            </div>
          </a-col>
          <a-col :span="6">
            <div class="label">{{ $t('deal.dealConfirm.projectInfo.contractBrokerage') }}</div>
            <div class="content">
              {{ contractVO.totalBrokerage }}
              <pt-unit-select type="currency" v-model="contractVO.totalBrokerageUnit"
                              :edit-mode="false"></pt-unit-select>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-row>
    <a-row>
      <div class="panel_header">
        <div class="circle"></div>
        <div class="panel_text">{{ $t('deal.dealConfirm.title') }}</div>
      </div>
    </a-row>
    <div class="info_block" id='myDiv'>
      <a-row>
        <div class="info_block"></div>
        <a-form :form="dealConfirmForm" layout="inline" selfUpdate>
          <a-row>
            <a-form-item :label="$t('dealConfirm.payerType.title')">
              <a-radio-group v-decorator="decorators.payerType" @change="changePayerType"
                             :disabled="onlyAttachmentAllow">
                <a-radio :value="3">{{ $t('dealConfirm.payerType.3') }}</a-radio>
                <a-radio :value="1">{{ $t('dealConfirm.payerType.1') }}</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-row>
        </a-form>
        <a-form :form="dealConfirmForm" selfUpdate layout="vertical">
          <a-form-item v-show="false">
            <a-input v-decorator="decorators.version"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="decorators.id"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="decorators.dealId"></a-input>
          </a-form-item>
          <a-row>
            <a-col :span="8">
              <a-form-item v-show="false">
                <pt-input v-decorator="decorators.payerName"></pt-input>
              </a-form-item>
              <a-form-item v-show="false">
                <pt-input v-decorator="decorators.payerShortName"></pt-input>
              </a-form-item>
              <a-form-item class="required" :label="$t('dealConfirm.payerId')">
                <a-select :placeholder="$t('dealConfirm.payerId')"
                          :disabled="onlyAttachmentAllow"
                          v-decorator="decorators.payerId"
                          showSearch
                          :filterOption="false"
                          :defaultActiveFirstOption="false"
                          :dropdownMatchSelectWidth="false"
                          :notFoundContent="null"
                          option-label-prop="label"
                          @search="initAllCompanyList"
                          @change="changeCompanyId"
                >
                  <a-icon slot="suffixIcon" type="caret-down"/>
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu"/>
                    <a-divider style="margin: 0;"/>
                    <div class="addCustomerBtn" @click="openAddCustomerModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div style="font-size: 12px;color: #ffffff;margin-left:4px;">
                        {{ payerType == 1 ? $t('track.trackModal.addCustomer') : $t('track.trackModal.addProprietor') }}
                      </div>
                    </div>
                  </div>
                  <a-select-option v-for="a in allCompanyList" :key="a.id" :value="a.id" :label="a.companyName">
                    <div>
                      <div style="display: flex;justify-content: space-between">
                        <span>{{ a.companyName }}</span>
                        <span style="margin-left: 30px;">{{ a.companySortNameCn }}</span>
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('dealConfirm.linkman')">
                <pt-input :placeholder="$t('news.agentForm.contactTip')" :disabled="onlyAttachmentAllow"
                          v-decorator="decorators.linkman"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item class="required" :label="$t('dealConfirm.linkmanContact')">
                <pt-input v-decorator="decorators.linkmanContact" :placeholder="$t('linkman.modal.mobilePhoneTip')"
                          :disabled="onlyAttachmentAllow"></pt-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>

            <a-col :span="8">
              <a-form-item :label="$t('dealConfirm.payeeName')" class="required">
                <pt-main-body-select :disabled="recallrejected" :deleteSelect="false" :allow-clear="false"
                                     @change="mainBodyChange" v-decorator="decorators.payeeIdStr" :isFirst="true"
                                     :expensed="true"
                                     :placeholder="$t('payment.addModal.selectPlaceholder')"></pt-main-body-select>
              </a-form-item>
            </a-col>

            <!--开票税率-->
            <a-col :span="8">
              <a-form-item :label="$t('dealConfirm.taxRate')+'(%)'">
                <pt-input v-decorator="decorators.taxRate" :disabled="true" :placeholder="$t('key82qingxuanzeshoukuanfang')"></pt-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('dealConfirm.expectPayeeTime')" class="required">
                <a-date-picker v-decorator="decorators.expectPayeeTime" @change="expectPayeeTimeChange" style="width: 100%"
                               :disabled="onlyAttachmentAllow" :disabled-date="disabledDate"></a-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="isShowRemarks">
            <a-col :span="24">
              <a-form-item :label="$t('keyyujishoukuanriqishuoming')" :class="days > 90 && dealConfirmVO.hkDeal == 2 ? 'required':''">
                <a-textarea :rows="3" v-decorator="['changeDataRemarks',{
                  rules: days > 90  && dealConfirmVO.hkDeal == 2  ? [{
                    required: true,
                    message: $t('keyyujishoukuanriqiqingshurushuoming'),
                  }]:[]
                }]" :disabled="onlyAttachmentAllow" :placeholder="$t('keyyujishoukuanriqiqingshurushuoming')"></a-textarea>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-row>
      <template v-if="isLeaseProject">
        <!-- 新增 代理协议 -->
        <div v-if="!agencyShow" style='margin-left: 15px'>
          <a-row v-if="showAgencySelector">
            <a-button style='background: #FABE00;border-radius: 2px;' size="small" @click="showAgency">
              <pt-icon type="icon-zengjia"></pt-icon>
              {{ $t('dealConfirm.agencyManagement') }}
            </a-button>
          </a-row>
        </div>
        <div v-else style="padding: 0 10px;">
          <agencySelector :agency-list="agencyList" :mansion-name="leaseInfoVO.mansionName"
                          :disabled="onlyAttachmentAllow"
                          :ownerName="ownerName" ref="agencySelectorRef" @hideAgency="hideAgency"
                          @openAddAgencyModal="openAddAgencyModal"></agencySelector>
        </div>
      </template>

      <!-- 其他附件 -->
      <div style='margin-left: 15px'>
        <a-row>
          <pt-oss-upload @onSuccess="onSuccess" :multiple="true" @onFinishSuccess="uploadFinish">
            <a-button size="small" style='background: #FABE00;border-radius: 2px;'>
              <pt-icon type="icon-shangchuanfujian"></pt-icon>
              {{ $t('dealConfirm.attachment') }}
            </a-button>
          </pt-oss-upload>
        </a-row>
        <a-row>
          <div v-for="(file,index) in fileList" :key="file.id" class="upload_files" style="background: #F2F4F6;">
            <a-divider v-if="index != 0" style="margin: 0;"/>
            <a-row class="deal_files">
              <a-col :span="2">
                <pt-icon type="icon-fujian" :styleObj="{fontSize: '22px'}"></pt-icon>
              </a-col>
              <a-col :span="18" style="flex: 1;font-size: 12px;color: #333333;display: flex; align-items: center;">
                {{ file.name }}
              </a-col>
              <a-col :span="4" style="display: flex;align-items: center;justify-content: flex-end;">
                <div @click="removeFile(file)">
                  <pt-icon type="icon-tubiao" :styleObj="{fontSize: '14px', cursor:'pointer'}"></pt-icon>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-row>
      </div>
    </div>
    <a-row>
      <a-col :span="24">
        <div class="panel_header" style='justify-content: space-between'>
          <div class='panel_header_text'>
            <div class="circle"></div>
            <div class="panel_text">{{ $t('deal.dealConfirm.dealConfirmPartake.title') }}</div>
          </div>
          <div class='panel_header_text'>
            <a-button :disabled="disabledTaxRate" size="small" @click='checkTaxChange' style="margin-right: 18px;">
              <pt-icon type="icon-zengjia"></pt-icon>
              {{ $t('key82shuifeichae') }}
            </a-button>
            <a-button :disabled="recallrejected" size="small" @click='checkChange'>
              <pt-icon type="icon-zengjia"></pt-icon>
              {{ $t('key82disanfangfenyong') }}
            </a-button>
          </div>
        </div>
      </a-col>

    </a-row>
    <div id='myDivTwo'>
      <a-row class="">
        <div class="info_block" style="margin-bottom: 5px;">
          <a-form :form="dealConfirmForm" selfUpdate>
            <a-row :gutter="16">
              <a-col :span="8">
                <a-form-item :label="$t('dealConfirm.totalComminssion')" class="required">
                  <pt-input-number @change="totalComminssionChange" :placeholder="$t('key82qingshuruyongjinshue')"
                                   :disabled="onlyAttachmentAllow || recallrejected"
                                   v-decorator="decorators.totalComminssion" :max="9999999999" :precision="2"
                                   style="width: 100%"></pt-input-number>
                  <pt-unit-select style="width: 30%;" type="currency" v-decorator="decorators.totalComminssionUnit"
                                  disabled v-show="false"></pt-unit-select>
                </a-form-item>
              </a-col>
              <a-col :span="16">
                <a-form-item :label="$t('key82fenpeifangshi')">
                  <a-radio-group v-model="dealConfirmVO.allocationType" @change="allocationTypeChange">
                    <a-radio :disabled="recallrejected" :value="1">
                      {{ $t('key82anzhaobilifenpei') }}
                    </a-radio>
                    <a-radio :disabled="recallrejected" :value="2">
                      {{ $t('key82anzhjaojingefenpei') }}
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="info_block">
          <a-form :form="dealConfirmPartakeForm" selfUpdate layout="vertical" >
            <a-row v-for="(d,index) in dealConfirmVO.dealConfrimPartakeDOList" :key="index">
              <div v-show="false">
                <a-form-item>
                  <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].id`,{}]" disabled></a-input>
                  <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].type`,{}]" disabled></a-input>
                </a-form-item>
                <a-form-item>
                  <pt-input
                    v-decorator="[`dealConfrimPartakeDOList[${index}].amountUnit`,{}]"></pt-input>
                </a-form-item>
                <a-form-item>
                  <pt-input
                    v-decorator="[`dealConfrimPartakeDOList[${index}].exchangedAmountUnit`,{}]"></pt-input>
                </a-form-item>
                <a-form-item>
                  <pt-input
                    v-decorator="[`dealConfrimPartakeDOList[${index}].exchangedAmount`,{}]"></pt-input>
                </a-form-item>
                <a-form-item>
                  <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].accountId`,{}]" disabled></a-input>
                </a-form-item>
              </div>
              <a-col :span="6">
                <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.accountId') : null">
                  <a-input :placeholder="$t('deal.dealConfirm.dealConfirmPartake.thirdAccountId')" v-decorator="[`dealConfrimPartakeDOList[${index}].name`,{
                               rules:[{required:true,message:$t('deal.dealConfirm.dealConfirmPartake.errorInfo.nameNull')}]
                               }]" :disabled="!d.isThird ||  recallrejected || d.type === 3"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="6" v-if="dealConfirmVO.allocationType == 1">
                <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.inverseProportion') : null">
                  <pt-input-number :placeholder="$t('deal.dealConfirm.dealConfirmPartake.thirdInverseProportion')"
                                   @change="calculateAmount(index)"
                                   :disabled="onlyAttachmentAllow || recallrejected || d.active"
                                   style="width:100%;"
                                   :max="100" :precision="2"
                                   v-decorator="[`dealConfrimPartakeDOList[${index}].inverseProportion`,{
                               rules:[{required:true,message:$t('deal.dealConfirm.dealConfirmPartake.errorInfo.inverseProportionNull')}]
                               }]"></pt-input-number>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.amount') : null">
                  <pt-input-number
                    :placeholder="dealConfirmVO.allocationType == 2 ?$t('key82qingshurufenpeijine') :$t('deal.dealConfirm.dealConfirmPartake.thirdAmount')"
                    :disabled="dealConfirmVO.allocationType == 1 || recallrejected || d.active"
                    style="width:100%;"
                    @change="commissionChangeValue"
                    :max="9999999999" :precision="2"
                    v-decorator="[`dealConfrimPartakeDOList[${index}].beforeTaxAmount`,{
                rules:[{required:true,message:$t('deal.dealConfirm.dealConfirmPartake.errorInfo.amountNull')}]
                }]"></pt-input-number>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.taxRage') : null">
                  <pt-input-number v-if="d.type == 1" :placeholder="$t('key82qingshurufenpeijine')"
                                   :disabled="true"
                                   style="width:100%;"
                                   :max="9999999999" :precision="2"
                                   v-decorator="[`dealConfrimPartakeDOList[${index}].amount`,{
                rules:[{required:true,message:$t('deal.dealConfirm.dealConfirmPartake.errorInfo.amountNull')}]
                }]"></pt-input-number>
                  <div style="text-align: left" v-else>~</div>
                </a-form-item>
              </a-col>
              <a-col :span="1" v-if="d.type != 1 && !recallrejected" style="padding-top: 14px;">
                <span @click="deleteThird(index)"><pt-icon type="icon-tubiao"></pt-icon></span>
              </a-col>
              <a-col :span="3">
                <a-form-item v-show="false"
                             :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.isConfirm') : null">
                  <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].isConfirm`,{}]" disabled></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item v-show="false"
                             :label="index == 0 ? $t('deal.dealConfirm.dealConfirmPartake.isConfirm') : null">
                  <a-input v-decorator="[`dealConfrimPartakeDOList[${index}].isThird`,{}]" disabled></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <a-form :form="dealConfirmForm" selfUpdate>
            <a-row>
              <a-col :span="24">
                <a-form-item :label="$t('deal.dealConfirm.remarks')">
                  <a-textarea :rows="3" v-decorator="decorators.remarks"
                              :placeholder="$t('dealConfirm.placeholder.remarks')"
                              :disabled="onlyAttachmentAllow"></a-textarea>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>

      </a-row>
    </div>
    <pt-modal :title="$t('dealConfirm.addAgentAgreement')" :visible="agencyVisible" :width="800"
              @cancel="hideAddAgency" @ok="submitAgency">
      <div slot="content">
        <addAgency
          ref="addAgencyAgreement" @saveSuccess="agencyAgreementSaveSuccess"></addAgency>
      </div>
    </pt-modal>
    <pt-modal :title="$t('dealConfirm.rentDetail')" :visible="projectDetailsVisible" :width="800"
              @cancel="hideProjectDetails" @ok="hideProjectDetails" :footer="true">
      <div slot="content">
        <leaseDetail :leaseId="leaseId" v-if="toShowLeaseDetails" :showTopButton="false"></leaseDetail>
        <contractDetails :contractVO="contractVO" v-else></contractDetails>
      </div>
    </pt-modal>
    <pt-modal :title="customerModalVisible ? customerModalTitle : proprietorModalTitle"
              :visible="customerModalVisible || proprietorModalVisible"
              @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
    >
      <div slot="content">
        <add-customer ref="customerModel" v-model="customerModalTitle" @saveSuccess="saveCustomerSuccess"
                      v-if="customerModalVisible"></add-customer>
        <addProprietor v-if="proprietorModalVisible" v-model="proprietorModalTitle" ref="addProprietorRef"
                       @saveSuccess="saveProprietorSuccess"></addProprietor>
      </div>
    </pt-modal>
    <pt-modal :title="$t('key135')"
              :visible="confirmVisiable"
               :width="650"
              @cancel="confirmVisiableCancel"
    >
      <div slot="content">
        <a-checkbox v-model="confirmCheck">{{$t('key136')}}<span style="color:#fabe00" @click.stop="menuClick({key:1})">《{{$t('key132')}}》</span>{{$t('key137')}}。</a-checkbox>
      </div>

      <div slot="footer">
        <a-button @click="confirmVisiableCancel">{{ $t('baseVO.cacel') }}</a-button>
        <a-button type="primary" :disabled="!confirmCheck" @click="validateSubmit">{{ $t('baseVO.confirm') }}</a-button>
      </div>
    </pt-modal>

  </div>
</template>

<script>
import linkmanApi from '@/api/database/linkman'
import customerApi from '@/api/mine/customer'
import deploymentApi, {selectOne} from '@/api/sys/deployment'
import ownerApi from '@/api/database/owner'
import dealApi, {getDealTeamUser} from '@/api/mine/deal'
import projectApi from '@/api/mine/projects/projects'
import agencyApi from '@/api/database/agencyAgreement'
import addAgency from '@/views/database/agencyAgreement/module/addAgencyAgreement'
import agencySelector from './agencySelector'
import contractDetails from '../../deal/contractDetails'
import leaseDetail from '../../../database/lease/module/leaseDetail'
import addCustomer from '../../../database/customer/module/addCustomer'
import addProprietor from '../../../database/proprietor/module/addProprietor'
import organizationAPI from '@/api/sys/organization'
import {mapState} from 'vuex'
import newObjectTag from '@/components/tag/newObjectTag'
import moment from "moment";

export default {
  name: 'newCommission',
  props: {
    update: {
      type: Boolean,
      default: false
    },
    dealId: {
      type: String,
      default: null
    },
    customerType: {
      type: String,
      default: 1,
    },
    customerId: {
      type: String,
      default: undefined,
    },
    recallrejected: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    addAgency, agencySelector, contractDetails, leaseDetail, addCustomer, addProprietor,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      expectPayeeTime:'',
      checkStatus: false,
      companyOptions: [],
      proprietorModalTitle: '',
      customerModalTitle: '',
      customerModalVisible: false,
      proprietorModalVisible: false,
      showAgencySelector: true,
      toShowLeaseDetails: false,
      confirmCheck: false,
      confirmVisiable: false,
      ownerName: null,
      leaseId: null,
      contractId: null,
      ownerId: null,
      agencyVisible: false,
      projectDetailsVisible: false,
      payerType: 3,
      agencyShow: false,
      dealConfirmVO: {},
      dealConfirmForm: this.$form.createForm(this, {}),
      dealConfirmPartakeForm: this.$form.createForm(this, {}),
      fileList: [],
      agencyList: [],
      allCompanyList: [],
      allLinkmanList: [],
      decorators: {
        version: ['version', {}],
        id: ['id', {}],
        dealId: ['dealId', {}],
        payerId: ['payerId', {rules: [{required: true, message: this.$t('deal.dealConfirm.errorInfo.payerId')}]}],
        linkman: ['payerLinkman', {
          rules: [{
            required: true,
            message: this.$t('deal.dealConfirm.errorInfo.payerLinkmanId')
          }]
        }],
        linkmanContact: ['payerLinkmanContact', {
          rules: [
            {required: true, message: this.$t('linkman.modal.mobilePhoneTip'),},
            {min: 2, max: 64, message: this.$t('linkman.modal.textMinLength'), trigger: 'blur'},
            {
              pattern: /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/,
              message: this.$t('customer.customerModal.phoneErrorTip'),
              trigger: 'blur'
            },
          ],
        }
        ],
        payeeIdStr: ['payeeIdStr', {rules: [{required: true, message: this.$t('deal.dealConfirm.errorInfo.payeeId')}]}],
        taxRate: ['taxRate', {rules: [{required: true, message: this.$t('deal.dealConfirm.errorInfo.payeeId')}]}],
        commissionRate: ['commissionRate', {}],
        totalComminssion: ['totalComminssion', {
          rules: [
            {required: true, message: this.$t('deal.dealConfirm.errorInfo.totalCommissionMissing')},
            {validator: this.validator}
          ]
        }],
        totalComminssionUnit: ['totalComminssionUnit', {}],
        expectPayeeTime: ['expectPayeeTime', {
          rules: [{
            required: true,
            message: this.$t('deal.dealConfirm.errorInfo.expectPayeeTime'),
          }]
        }],
        receiptNum: ['receiptNum', {}],
        receiptTime: ['receiptTime', {}],
        remarks: ['remarks', {
          rules: [{
            min: 2,
            max: 256,
            message: this.$t('deal.dealConfirm.errorInfo.remarksLength')
          }]
        }],
        payerType: ['payerType', {
          initialValue: 3,
          rules: [{required: true, message: this.$t('deal.dealConfirm.errorInfo.payerType')}]
        }],
        agencyId: ['agencyId', {}],
        payerName: ['payerName', {}],
        payerShortName: ['payerShortName', {}],
      },
    }
  },
  computed: {
    days(){
      console.log("dealConfrimVo",this.dealConfirmVO)
      if(this.expectPayeeTime && this.dealConfirmVO.id == "0"){
        console.log("dealConfrimVo",this.$moment(this.expectPayeeTime).diff(this.$moment(),'days'))
        return this.$moment(this.expectPayeeTime).startOf('days').diff(this.$moment().startOf('days'),'days')
      }else if(this.expectPayeeTime && this.dealConfirmVO.id){
        return this.$moment(this.expectPayeeTime).startOf('days').diff(this.$moment(this.dealConfirmVO.createTime).startOf('days'),'days')
      }else{
        return 0
      }
    },
    isShowRemarks(){
      if(this.dealConfirmVO.id == "0"){
        return true;
      }else{
        return this.$moment(this.expectPayeeTime).format("YYYY-MM-DD") != this.$moment(this.dealConfirmVO.expectPayeeTime).format("YYYY-MM-DD")
      }
    },
    disabledTaxRate() {
      if (this.dealConfirmVO.dealConfrimPartakeDOList.filter(data => data.type === 3).length > 0 || this.dealConfirmVO.dealConfrimPartakeDOList.filter(data => data.type === 2).length === 0) {
        return true
      } else {
        return false
      }
    },
    onlyAttachmentAllow() {
      if (this.update && this.dealConfirmVO.rejected && this.dealConfirmVO.rejectedReason == 'attachment') {
        return true
      } else {
        return false
      }
    },
    dealDO() {
      if (this.dealConfirmVO) {
        return this.dealConfirmVO.dealDO
      } else {
        return {}
      }
    },
    isLeaseProject() {
      if (!this.dealConfirmVO) {
        return false
      }
      if (this.dealConfirmVO.dealDO) {
        return this.dealConfirmVO.dealDO.dealOriginType != 2
      } else {
        return false
      }
    },
    contractVO() {
      if (this.dealConfirmVO) {
        return this.dealConfirmVO.contractVO
      } else {
        return {}
      }
    },

    allocationTypeChange(event) {

      if (this.dealConfirmVO.allocationType == 1) {
        this.dealConfirmVO.dealConfrimPartakeDOList.forEach(data => {
          data.beforeTaxAmount = 0;
          data.inverseProportion = undefined;
          data.amount = undefined;
        })
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: this.dealConfirmVO.dealConfrimPartakeDOList})
      } else {
        this.dealConfirmVO.dealConfrimPartakeDOList.forEach(data => {
          data.beforeTaxAmount = undefined;
          data.amount = undefined;
        })
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: this.dealConfirmVO.dealConfrimPartakeDOList})
      }
    },
    leaseInfoVO() {
      if (this.dealConfirmVO) {
        return this.dealConfirmVO.leaseLeaseInfoVO
      } else {
        return {}
      }
    },
    leaseAreaInfo() {
      if (this.dealConfirmVO) {
        let totalSize = 0
        if (this.dealConfirmVO.leaseLeaseInfoVO != '~') {
          this.dealConfirmVO.leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.forEach(e => {
            totalSize += e.areaSize
          })
        }
        return totalSize
      } else {
        return 0
      }
    },
    leaseAreaUnit() {
      if (this.dealConfirmVO) {
        if (this.dealConfirmVO.leaseLeaseInfoVO != '~') {
          return this.dealConfirmVO.leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList.length > 0 ? this.dealConfirmVO.leaseLeaseInfoVO.leaseLeaseInfoDetailsVOList[0].areaSizeUnit : null
        } else {
          return null
        }
      } else {
        return null
      }
    },
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    menuClick({ key  }){
      if(key == 1){
        window.open("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/opt/ChargeOut.pdf","_black")
      }else if(key == 2){
        window.open("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/opt/thirdParty.pdf","_black")
      }else{
        window.open("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/opt/confirm-email.pdf","_black")
      }
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day') || current > moment().add(180,'day') ;
    },
    expectPayeeTimeChange(value){
      console.log("change========",value)

        this.expectPayeeTime = value.format("YYYY-MM-DD")
      this.dealConfirmForm.resetFields(['changeDataRemarks'])
    },
    mainBodyChange(value, mainBody) {
      console.log("mainBodyChange", value, mainBody)
      if (this.dealConfirmVO.id != '0') {
        if (this.dealConfirmVO.payeeId == mainBody.id) {
          this.dealConfirmForm.setFieldsValue({"taxRate": this.dealConfirmVO.taxRate})
        } else {
          if (mainBody.id) {
            this.dealConfirmForm.setFieldsValue({"taxRate": mainBody.taxRate})
          }

        }

      } else {
        if (mainBody.id) {
          this.dealConfirmForm.setFieldsValue({"taxRate": mainBody.taxRate})
        }
      }
      this.totalComminssionChange();
    },
    checkTaxChange(e) {
      console.log("======this.userInfo", this.userInfo)
      let dealConfrimDO = {};
      dealConfrimDO.isThird = true;
      dealConfrimDO.type = 3;
      dealConfrimDO.isConfirm = 1;
      dealConfrimDO.name = "税费差额";
      dealConfrimDO.id = -1;
      this.dealConfirmVO.dealConfrimPartakeDOList.push(dealConfrimDO)
      let keys = this.dealConfirmPartakeForm.getFieldValue("dealConfrimPartakeDOList");
      keys.push(dealConfrimDO)
      console.log('------', keys)
      this.$nextTick(() => {
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: keys})
        this.totalComminssionChange();
      })
      console.log('------', this.dealConfirmPartakeForm.getFieldValue("dealConfrimPartakeDOList"))
    },
    checkChange(e) {
      console.log("======this.userInfo", this.userInfo)
      let dealConfrimDO = {};
      dealConfrimDO.isThird = true;
      dealConfrimDO.type = 2;
      dealConfrimDO.isConfirm = 1;
      dealConfrimDO.id = -1;
      this.dealConfirmVO.dealConfrimPartakeDOList.push(dealConfrimDO)
      let keys = this.dealConfirmPartakeForm.getFieldValue("dealConfrimPartakeDOList");
      keys.push(dealConfrimDO)
      console.log('------', keys)
      this.$nextTick(() => {
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: keys})
        this.totalComminssionChange();
      })
      console.log('------', this.dealConfirmPartakeForm.getFieldValue("dealConfrimPartakeDOList"))
    },
    deleteThird(index) {
      let keys = this.dealConfirmPartakeForm.getFieldsValue().dealConfrimPartakeDOList
      let result = this.dealConfirmPartakeForm.getFieldValue("dealConfrimPartakeDOList");
      console.log('------keys', keys)
      let dealConfrimPartake = keys.filter((item, i) => i != index)
      console.log('------', dealConfrimPartake)
      console.log('------', this.dealConfirmPartakeForm.getFieldValue("dealConfrimPartakeDOList"))
      this.dealConfirmVO.dealConfrimPartakeDOList.splice(index, 1)

      this.$nextTick(() => {
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: result.filter((item, i) => i != index)})
        // this.totalComminssionChange();
      })
    },
    initCompanyOptions() {

    },
    validator(rule, value, cb) {
      if (value && value <= 0) {
        cb(new Error(this.$t('deal.addDeal.errorInfo.amountLeZero')))
      } else {
        cb()
      }
    },
    removeFile(file) {
      this.fileList.splice(this.fileList.indexOf(file), 1)
    },
    saveCustomer() {
      if (this.payerType == 1) {
        this.$refs.customerModel.submit();
      } else {
        this.$refs.addProprietorRef.submit()
      }
    },
    cancelAddCustomer() {
      this.proprietorModalVisible = false
      this.customerModalVisible = false;
    },
    saveProprietorSuccess(id, name, owner) {
      this.setDefaultCustomerDO(id, name, owner);
      this.proprietorModalVisible = false;
    },
    saveCustomerSuccess(id, name, customer) {
      this.setDefaultCustomerDO(id, name, customer);
      this.customerModalVisible = false;
    },
    setDefaultCustomerDO(id, name, customer) {
      this.allCompanyList = [];
      let customerDO = {
        id: id,
        companyName: name,
        companySortNameCn: customer.companySortNameCn
      }
      this.allCompanyList.push(customerDO);
      this.dealConfirmForm.setFieldsValue({
        payerId: id
      })
    },
    openAddCustomerModal() {
      if (this.payerType == 1) {
        this.customerModalVisible = true;
      } else {
        this.proprietorModalVisible = true
      }
    },
    agencyAgreementSaveSuccess() {
      this.initAgencyAgreement(this.ownerId)
      this.hideAddAgency()
    },
    commissionChangeValue() {
      console.log("计算固定金额分配")
      if (this.dealConfirmVO.allocationType == 2) {
        let taxRate = this.dealConfirmForm.getFieldsValue().taxRate
        let brokerageAllocation = this.dealConfirmPartakeForm.getFieldsValue().dealConfrimPartakeDOList
        for (let i = 0; i < brokerageAllocation.length; i++) {
          if (brokerageAllocation[i].beforeTaxAmount) {
            brokerageAllocation[i].amount = (brokerageAllocation[i].beforeTaxAmount / (1 + (taxRate / 100))).toFixed(2)
          } else {
            brokerageAllocation[i].amount = "0"
          }

        }
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: brokerageAllocation})
      }

    },
    calculateAmount(index) {
      if (this.dealConfirmVO.allocationType == 1) {
        this.$nextTick(() => {
          let totalCommission = this.dealConfirmForm.getFieldsValue().totalComminssion
          let taxRate = this.dealConfirmForm.getFieldsValue().taxRate
          if (typeof totalCommission != "number") {
            totalCommission = parseFloat(totalCommission.replace(/,/g, ''))
          }
          let brokerageAllocation = this.dealConfirmPartakeForm.getFieldsValue().dealConfrimPartakeDOList
          let percent = brokerageAllocation[index].inverseProportion
          if (typeof percent == "number") {
            brokerageAllocation[index].beforeTaxAmount = (totalCommission * parseFloat(brokerageAllocation[index].inverseProportion) / 100).toFixed(2)
            brokerageAllocation[index].amount = (brokerageAllocation[index].beforeTaxAmount / (1 + (taxRate / 100))).toFixed(2)
          } else {
            brokerageAllocation[index].beforeTaxAmount = 0
          }
          //计算是否有剩余
          let subAmout = 0;
          brokerageAllocation.forEach((data, idx) => {
            if (index != idx) {
              subAmout = subAmout + parseFloat(data.beforeTaxAmount);
            }
          })
          let amount = totalCommission - subAmout;
          if (amount) {
            brokerageAllocation[0].beforeTaxAmount = brokerageAllocation[0].beforeTaxAmount + amount
            brokerageAllocation[0].amount = (brokerageAllocation[0].beforeTaxAmount / (1 + (taxRate / 100))).toFixed(2)
          }
          this.totalComminssionChange()
        })
      }
    },
    changePayerType(value) {
      this.payerType = value.target.value
      this.dealConfirmForm.setFieldsValue({payerId: undefined})
      if (value.target.value == 3) {
        this.showAgencySelector = true
      } else {
        this.showAgencySelector = false
      }
      this.initAllCompanyList()
    },
    commissionRateChange(value) {
      let totalSize = 0
      for (let i = 0; i < this.leaseInfoVO.leaseLeaseInfoDetailsVOList.length; i++) {
        totalSize += this.leaseInfoVO.leaseLeaseInfoDetailsVOList[i].areaSize
      }
      let commissionAmount = this.leaseInfoVO.rent * totalSize * value / 100
      this.dealConfirmForm.setFieldsValue({totalComminssion: commissionAmount})
      this.totalComminssionChange()
    },
    changeCompanyId(value) {
      this.initAllLinkmanList(value)
      this.initAgencyAgreement(value)
      this.ownerId = value
      let company = this.allCompanyList.find(e => {
        return e.id == value
      })
      this.ownerName = company.companyName
      this.dealConfirmForm.setFieldsValue({
        payerName: company.companyName,
        payerShortName: company.companySortNameCn
      })
    },
    hideAgency() {
      this.agencyShow = false
    },
    hideProjectDetails() {
      this.projectDetailsVisible = false
    },
    hideAddAgency() {
      this.agencyVisible = false
    },
    init() {
      this.initCompanyOptions()
      if (this.payerType != '0' && this.customerId != '0') {
        this.initCustomerOptions(this.customerId).then(res => {
          this.initAgencyAgreement(this.customerId);
          /* if(this.payerType == '3'){
              this.initAgencyAgreement(this.customerId);
            }*/
          if (!this.update) {
            this.initDefaultValue()
          }
        })
      }
    },
    initDefaultValue() {
      this.dealConfirmForm.setFieldsValue({
        payerType: 3,
        payerId: undefined,
        payerName: undefined,
        payerShortName: undefined,
        payerLinkman: undefined,
        payerLinkmanContact: undefined,
        remarks: undefined
      })
    },
    initAgencyAgreement(ownerId) {
      agencyApi.selectByOnwerIdAndMansionId(ownerId, this.leaseInfoVO.mansion).then(res => {
        if (res.code == 1) {
          this.agencyList = res.data
          if (this.agencyList.length > 0) {
            this.agencyShow = true
          }
        } else {

        }
      })
    },
    initAllLinkmanList(value) {
      let company = this.allCompanyList.find(e => {
        return e.id == value
      })
      let p = new Promise((resolve, reject) => {
        linkmanApi.listByTypeAndCompanyId(this.payerType, company.id).then(res => {
          if (res.code == 1) {
            this.allLinkmanList = res.data
            resolve()
          } else {
            reject()
          }
        })
      })
      return p
    },
    initCustomerOptions(id) {
      let this_ = this
      if (this.payerType == 1) {
        let p = new Promise((resolve, reject) => {
          customerApi.selectOne(id).then(res => {
            if (res.code == 1) {
              this_.allCompanyList = [res.data]
              resolve()
            } else {
              reject()
            }
          })
        })
        return p
      } else {
        let p = new Promise((resolve, reject) => {
          ownerApi.selectOne(id).then(res => {
            if (res.code == 1) {
              if (this.update) {
                this_.allCompanyList = [res.data]
                this_.ownerId = id
                this_.ownerName = this_.allCompanyList[0].companyName
              }
              resolve()
            } else {
              reject()
            }
          })
        })
        return p
      }
    },
    initAllCompanyList(companyName) {
      if (!companyName) {
        this.allCompanyList = []
        return
      }
      let this_ = this
      let p = new Promise((resolve, reject) => {
        if (this_.payerType == 1) {
          customerApi.queryByName({name: companyName}).then(res => {
            if (res.code == 1) {
              this.allCompanyList = res.data != null ? res.data : []
              resolve()
            } else {
              reject()
            }
          })
        } else {
          ownerApi.queryByName({name: companyName}).then(res => {
            if (res.code == 1) {
              this.allCompanyList = res.data != null ? res.data : []
              resolve()
            } else {
              reject()
            }
          })
        }
      })
      return p
    },
    onSuccess(file, fileId, number) {
      this.fileList.push(Object.assign(file, {fileId: fileId}))
    },
    openAddAgencyModal() {
      this.agencyVisible = true
    },
    selectDealConfirmVO(dealConfirmVO) {
      console.log("selectDealConfirmVO")
      this.dealConfirmVO = JSON.parse(JSON.stringify(dealConfirmVO))
      this.payerType = this.dealConfirmVO.payerType
      this.expectPayeeTime = this.dealConfirmVO.expectPayeeTime
      this.setDefaultValue()

    },
    setDefaultValue() {
      let dealConfirmVO = JSON.parse(JSON.stringify(this.dealConfirmVO))
      console.log("setDefaultValue", dealConfirmVO)
      this.$nextTick(() => {
        dealConfirmVO.payerLinkmanId = null
        if (this.payerType == '0') {
          this.payerType = 3
          dealConfirmVO.payerId = undefined
        }
        dealConfirmVO.payerType = this.payerType
        if (this.payerType == 3) {
          this.showAgencySelector = true
        } else {
          this.showAgencySelector = false
        }
        if (this.update) {
          if (dealConfirmVO.dealConfirmFileVOS) {
            this.fileList = dealConfirmVO.dealConfirmFileVOS.map(e => {
              return {fileId: e.fileId, id: e.fileId, name: e.fileName}
            })
          }
          if (dealConfirmVO.agencyId != '0') {
            this.initAgencyAgreement(dealConfirmVO.payerId)
            this.agencyShow = true
            this.$nextTick(() => {
              this.$refs.agencySelectorRef.setDefaultValue(dealConfirmVO.agencyId)
            })
          } else {
            dealConfirmVO.agencyId = undefined
          }
          this.initCustomerOptions(this.dealConfirmVO.payerId);
        }
        dealConfirmVO.expectPayeeTime = dealConfirmVO.expectPayeeTime != '~' ? this.$moment(dealConfirmVO.expectPayeeTime) : undefined
        dealConfirmVO.remarks == '~' && (dealConfirmVO.remarks = undefined)
        this.dealConfirmForm.setFieldsValue(dealConfirmVO)
        if (!dealConfirmVO.id) {
          this.dealConfirmPartakeForm.setFieldsValue(dealConfirmVO)
        } else {
          this.queryTeamUsers(dealConfirmVO);
        }

      })
    },
    queryTeamUsers(dealConfirmVO) {
      let accountIds = [];
      dealConfirmVO.dealConfrimPartakeDOList.forEach((data) => {
        accountIds.push(data.accountId);
      })
      if (dealConfirmVO.type == 1) {
        dealApi.getDealTeamUser(dealConfirmVO.dealDO.id).then(res => {
          if (res.code == 1) {
            let dealAccountList = res.data;
            dealAccountList.forEach(data => {
              if (accountIds.indexOf(data.accountId) == -1) {
                data.isThird = false;
                dealConfirmVO.dealConfrimPartakeDOList.push(data);
                this.dealConfirmVO.dealConfrimPartakeDOList.push(data);
              }
            })
            this.$nextTick(() => {
              this.dealConfirmPartakeForm.setFieldsValue(dealConfirmVO)
            });
          }
        })
      } else {
        projectApi.getProjectTeamUser(dealConfirmVO.dealId).then(res => {
          if (res.code == 1) {
            let dealAccountList = res.data;
            dealAccountList.forEach(data => {
              if (accountIds.indexOf(data.accountId) == -1) {
                data.isThird = false;
                dealConfirmVO.dealConfrimPartakeDOList.push(data);
                this.dealConfirmVO.dealConfrimPartakeDOList.push(data);
              }
            })
            this.$nextTick(() => {
              this.dealConfirmPartakeForm.setFieldsValue(dealConfirmVO)
            });
          }
        })
      }

    },
    showAgency() {

      console.log('1', this.update)
      console.log('2', this.dealConfirmVO.rejected)
      console.log('3', this.dealConfirmVO.rejectedReason)

      if (!this.onlyAttachmentAllow) {
        this.agencyShow = true
      }
    },
    showLeaseDetails() {
      if (this.dealConfirmVO.dealDO.dealOriginType == 1) {
        this.toShowLeaseDetails = true
        this.leaseId = this.dealConfirmVO.leaseLeaseInfoVO.id
      } else {
        this.toShowLeaseDetails = false
        this.contractId = this.dealConfirmVO.contractVO.id
      }
      this.projectDetailsVisible = true
    },
    submit(dealConfirmVO) {
      dealConfirmVO.dealConfirmFileVOS = this.fileList
      dealConfirmVO.type = this.dealConfirmVO.type;
      dealApi.getCompanyId().then(res => {
        if (res.code == 1) {
          deploymentApi.selectOne(10, res.data).then(str => {
            if (str.code == 1) {
              console.log("deploymentApi", str)
              if (str.data.length == 0) {
                this.$message.warning(this.$t('deal.warningNew'))
                this.$emit('saveCommissionFail')
              } else {
                if (this.recallrejected) {
                  dealApi.updateDealConfirm(dealConfirmVO).then(rts => {
                    if (rts.code == 1) {
                      this.$message.success(rts.message)
                      this.$emit('saveCommissionSuccess')
                    } else {
                      this.$emit('saveCommissionFail')
                    }
                  })
                } else {
                  dealApi.insertDealConfirm(dealConfirmVO).then(rts => {
                    if (rts.code == 1) {
                      this.$message.success(rts.message)
                      this.$emit('saveCommissionSuccess')
                    } else {
                      this.$emit('saveCommissionFail')
                    }
                  })
                }

              }
            } else {
              this.$emit('saveCommissionFail')
            }
          })
        } else {
          this.$emit('saveCommissionFail')
        }
      })

    },
    submitAgency() {
      this.$refs.addAgencyAgreement.submit()
    },
    totalComminssionChange(values) {
      if (this.dealConfirmVO.allocationType == 1) {
        let value = values ? values : this.dealConfirmForm.getFieldsValue().totalComminssion
        let taxRate = this.dealConfirmForm.getFieldsValue().taxRate
        if (typeof value != "number") {
          value = parseFloat(value.replace(/,/g, ''))
        }
        let brokerageAllocation = this.dealConfirmPartakeForm.getFieldsValue().dealConfrimPartakeDOList
        let subAmount = 0;
        let inverseProportionCount = 0;
        for (let i = 0; i < brokerageAllocation.length; i++) {
          if (typeof brokerageAllocation[i].inverseProportion == 'number') {
            brokerageAllocation[i].beforeTaxAmount = (value * brokerageAllocation[i].inverseProportion / 100).toFixed(2) + ""
            brokerageAllocation[i].amount = (brokerageAllocation[i].beforeTaxAmount / (1 + (taxRate / 100))).toFixed(2)
            subAmount = subAmount + parseFloat((value * brokerageAllocation[i].inverseProportion / 100).toFixed(2));
            inverseProportionCount++;
          } else {
            brokerageAllocation[i].beforeTaxAmount = "0";
          }
        }
        this.dealConfirmPartakeForm.setFieldsValue({dealConfrimPartakeDOList: brokerageAllocation})
      }
    },
    validateSubmit(){
      this.confirmVisiable = false;
      this.dealConfirmForm.validateFields(err => {
        if (!err) {
          this.dealConfirmPartakeForm.validateFields(err2 => {
            if (!err2) {
              let dealConfirmVO = this.dealConfirmForm.getFieldsValue()
              Object.assign(dealConfirmVO, this.dealConfirmPartakeForm.getFieldsValue())
              if (!this.update) {
                dealConfirmVO.dealId = this.dealId
              }
              if (this.$refs.agencySelectorRef) {
                Object.assign(dealConfirmVO, this.$refs.agencySelectorRef.getAgencyId())
              }
              if (this.validateAmount(dealConfirmVO)) {
                dealConfirmVO.allocationType = this.dealConfirmVO.allocationType;
                this.submit(dealConfirmVO)
              }
            } else {
              this.$message.warning("请正确输入表单");
              this.$emit('cancelLoading')
            }
          })
        } else {
          this.$message.warning("请正确输入表单");
          this.$emit('cancelLoading')
        }
      })
    },
    confirmVisiableCancel(){
      this.confirmVisiable = false;
      this.$emit('cancelLoading')
    },
    validate() {
      this.confirmVisiable = true;
    },
    validateAmount(dealConfirmVO) {
      if (dealConfirmVO.allocationType == 1) {
        let totalComminssion = 0
        if (typeof dealConfirmVO.totalComminssion != "number") {
          // totalComminssion = parseFloat(dealConfirmVO.totalComminssion.replace(/,/g,'')) * 100
          totalComminssion = parseFloat(dealConfirmVO.totalComminssion.replace(/,/g, ''))
        } else {
          // totalComminssion = dealConfirmVO.totalComminssion * 100
          totalComminssion = dealConfirmVO.totalComminssion
        }
        let partakeSum = this.$math.bignumber(0)
        let totalPercent = this.$math.bignumber(0)
        for (let i = 0; i < dealConfirmVO.dealConfrimPartakeDOList.length; i++) {
          if (typeof dealConfirmVO.dealConfrimPartakeDOList[i].amount == "number") {
            // partakeSum += dealConfirmVO.dealConfrimPartakeDOList[i].amount * 100
            partakeSum = this.$math.add(this.$math.bignumber(dealConfirmVO.dealConfrimPartakeDOList[i].amount), partakeSum)
          } else {
            // partakeSum += parseFloat(dealConfirmVO.dealConfrimPartakeDOList[i].amount.replace(/,/g,'')) * 100
            partakeSum = this.$math.add(this.$math.bignumber(parseFloat(dealConfirmVO.dealConfrimPartakeDOList[i].amount.replace(/,/g, ''))), partakeSum)
          }
          // totalPercent += dealConfirmVO.dealConfrimPartakeDOList[i].inverseProportion
          totalPercent = this.$math.add(this.$math.bignumber(dealConfirmVO.dealConfrimPartakeDOList[i].inverseProportion), totalPercent)
        }
        //
        // if(this.$math.compare(totalComminssion,partakeSum).toNumber() != 0 ){
        //   this.$emit('saveCommissionFail')
        //   this.$message.error(this.$t('deal.dealConfirm.errorInfo.commissionAmount'))
        //   return false
        // }
        // if(this.$math.compare(100,totalPercent).toNumber() != 0){
        //   this.$emit('saveCommissionFail')
        //   this.$message.error(this.$t('deal.dealConfirm.errorInfo.commissionPercent'))
        //   return false
        // }
        return true
      } else {
        return true;
      }

    }
  }
}
</script>

<style scoped lang="less">

#myDiv {
  .ant-row {
    padding: 10px 10px 10px 5px !important;
  }
}

#myDivTwo {
  .ant-row {
    padding: 10px 10px 10px 5px !important;
  }
}


.addCustomerBtn {
  background: #3B2E26;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;

  .addIcon {
    color: #ffffff;
    font-size: 12px;
  }
}

#newCommission {
  .project_name {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .info_block {
    background: rgba(248, 249, 251, 0.62);
    border-radius: 0 0 4px 4px;
  }

  .ant-row {
    padding: 10px 0px;
  }

  .panel_header {
    display: flex;
    align-items: center;

    .panel_header_text {
      display: flex;
      align-items: center;
    }

    .circle {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #FABE00;
    }

    .panel_text {
      padding: 0 10px;
      color: #333333;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .label {
    font-size: 12px;
    color: #999999;
  }

  .content {
    font-size: 12px;
    color: #333333;
  }

}

/deep/ .invisible-item {
  display: none;
}
</style>

<style lang="less">
.ant-select-dropdown-content {
  /deep/ .invisible-item {
    display: initial !important;
  }
}
</style>